"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trustedVerificationStatusRepository = void 0;
const resolver_1 = require("./resolver");
const mapper_1 = require("./mapper");
exports.trustedVerificationStatusRepository = {
    isVerified: async (api, progressId, data) => {
        const response = await (0, resolver_1.fetchCheckTrustedVerificationStatus)(api, progressId, data);
        return (0, mapper_1.mapIsVerified)(response.data);
    },
};
//# sourceMappingURL=repository.js.map